import { useRef, useState } from 'react'

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'

export { SplitButton }

type Props = {
  options: {
    label: string
    onClick: () => void
  }[]
}

const SplitButton = ({ options }: Props) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)

  /* v8 ignore next -- @preserve */
  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return
    }

    setOpen(false)
  }

  return options.length > 0 ? (
    <>
      <ButtonGroup variant="contained" ref={anchorRef}>
        <Button
          onClick={() => {
            setOpen(false)
            options[0].onClick()
          }}
        >
          {options[0].label}
        </Button>

        {options.length > 1 && (
          <Button size="small" onClick={() => setOpen((prevOpen) => !prevOpen)}>
            <ArrowDropDownIcon />
          </Button>
        )}
      </ButtonGroup>

      <Popper
        sx={{ zIndex: 1 }}
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'right top' }}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList>
                  {options
                    /** First option is primary action */
                    .filter((_, index) => index !== 0)
                    .map((option) => (
                      <MenuItem
                        key={option.label}
                        onClick={() => {
                          option.onClick()
                          setOpen(false)
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  ) : null
}
